export default __webpack_public_path__ + "static/media/story_cover_image.67632449.png";